"use client";

import { show } from "@intercom/messenger-js-sdk";
import { Button } from "../ui/button";

export default function ShowChatButton() {
  return (
    <Button onClick={() => show()} variant="link" size="sm" className="px-0">
      Show
    </Button>
  );
}
